import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TbExclamationCircle } from 'react-icons/tb';
import './ClipAlert.scss';

const ClipAlert = ({ title, message }) => {
    return (
        <Row className="alert">
            <TbExclamationCircle size={25} className="alert__icon" />
            <Col className="alert__container">
                {title && <span className='alert__title'>{title}</span>}
                <span className='alert__desc'>{message}</span>
            </Col>
        </Row>
    );
};

export default ClipAlert;
